import React from "react";
import Popup from "./popup";
import { WorthyThemeProvider, Button } from "@worthy-npm/worthy-ui-components";

export class ConfirmationPopup extends Popup {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    static initPopup(props = {}) {
        props.stopAnimation ? props.stopAnimation() : null;
        Popup.initPopup.call(this, props);
    }

    _onPopupClose() {
        if (this.props.stopAnimation) {
            this.props.stopAnimation();
        }
    }

    _hide = () => {
        super._hide();
    };

    confirm = async () => {
        this.setState({ loading: true });
        const { onConfirm } = this.props;
        await onConfirm();
        this._hide();
    };

    cancel = async () => {
        this.setState({ loading: true });
        const { onCancel } = this.props;
        await onCancel();
        this._hide();
    };

    title = () => {
        const { title } = this.props;
        return title;
    };

    footer = () => {
        const { confirmText, cancelText } = this.props;
        const { loading } = this.state;

        return (
            <>
                <div className="shipBack--button-group">
                    <Button
                        variant="text"
                        onClick={this.cancel}
                        isDisabled={loading}
                    >
                        {cancelText}
                    </Button>
                    <Button onClick={this.confirm} isDisabled={loading}>
                        {confirmText}
                    </Button>
                </div>
            </>
        );
    };

    content = () => {
        const { message } = this.props;

        return (
            <WorthyThemeProvider>
                <p>{message}</p>
                {this.footer()}
            </WorthyThemeProvider>
        );
    };
}

ConfirmationPopup.defaultProps = {
    title: "Confirm",
    message: "Are you sure?",
    confirmText: "Confirm",
    cancelText: "Cancel",
    popupClassName: "confirmation-popup",
    single: true,
    modal: true,
    onConfirm: function () {},
    onCancel: function () {},
    onPopupClose: function () {
        this._onPopupClose();
    },
};

export default ConfirmationPopup;
